import axios, { AxiosInstance } from "axios";

export function createAxiosInstance(baseURL: string): AxiosInstance {
  const axiosInstance = axios.create({
    baseURL: baseURL,
  });

  axiosInstance.interceptors.request.use(
    async (request) => {
      try {
        const accessToken = localStorage.getItem("carePlanDownloadToken");
        request.headers.authorizationToken = `Bearer ${accessToken}`;
      } catch (error) {
        console.error("Error acquiring token:", error);
      }

      return request;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  return axiosInstance;
}
